import React from "react";
import Subheading from "@hui/_atoms/subheading/Subheading";
import { iTourStep } from "./types";
import I18n from "../../../../utilities/translations";
import { postStepOverview, StepOverviewState } from "../../../../API/onboarding/step_overview.api";
import CompleteTourStep from "./CompleteTourStep";
import CurrentTourStep from "./CurrentTourStep";
import IncompleteTourStep from "./IncompleteTourStep";
import FormWrapper from "../Shared/FormWrapper";
import FormBody from "../Shared/FormBody";
import FormButton from "../Shared/FormButton";

const StepOverview = ({ state, stateUpdate }: { state: StepOverviewState, stateUpdate: (...args) => void }) => {
  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      const res = await postStepOverview(state);
      stateUpdate(res.data.state);
    } catch (err) {
      toastr.error("Something went wrong, please try again");
      throw err;
    }
  };

  const buildSteps = () => {
    const data: iTourStep[] = Object.values(I18n.t("onboarding.v3.step_overview.step_data"));

    const currentStepNumber = Number(state.at(-1)) + 1;

    return data.map((step) => {
      if (step.number < currentStepNumber) return <CompleteTourStep key={step.number} {...step} />
      if (step.number === currentStepNumber) return <CurrentTourStep key={step.number} {...step} />
      return <IncompleteTourStep key={step.number} {...step} />
    })
  };

  return (
    <FormWrapper>
      <form onSubmit={onSubmit} className="tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden">
        <FormBody>
          <Subheading>{I18n.t("onboarding.v3.step_overview.required_text")}</Subheading>
          <div className="tw-flex tw-flex-col tw-gap-3">
            {buildSteps()}
          </div>
        </FormBody>
        <FormButton classes="tw-flex tw-flex-col tw-gap-3">
          <input type="submit" title="Next" value="Next" className="hnry-button hnry-button--primary tw-w-full"/>
          <a title="I'll do it later" href="/" className="hnry-button hnry-button--secondary tw-w-full">I'll do it later</a>
        </FormButton>
      </form>
    </FormWrapper>
  );
};

export default StepOverview;
